import { FloatElement } from 'src/scripts/components/float-element'
import { BaseComponent } from '../../components/base-component'
import { $el, $elParent, $list } from 'src/scripts/utils/utils'
import { replaceNodeChildren } from 'src/scripts/utils/dom'

const FLOAT_ELEMENT_SELECTOR = 'float-element'
const INPUT_SELECTOR = 'input'
const DROPDOWN_TOGGLE_LABEL_SELECTOR = '.dropdown__toggle-label'
const DROPDOWN_ITEM_SELECTOR = '.dropdown__item'
const DROPDOWN_SELECTOR = 'float-element'
const DROPDOWN_OPTION_SELECTOR = 'option'

export class CountrySelector extends BaseComponent {
  mountComponent(): void {
    this.createItems()

    this.addListener(this, 'click', this.handleItemClick)
  }

  handleItemClick = (event: MouseEvent): void => {
    const dropdown: FloatElement = $el(FLOAT_ELEMENT_SELECTOR, this)
    const input: HTMLInputElement = $el(INPUT_SELECTOR, this)
    const dropdownBtnLabel = $el(DROPDOWN_TOGGLE_LABEL_SELECTOR, this)
    const target = event.target as HTMLElement
    const item = $elParent(DROPDOWN_ITEM_SELECTOR, target)

    if (!item) {
      return
    }

    if (!input || !dropdownBtnLabel || !dropdown) {
      return
    }

    input.setAttribute('value', target.dataset.value)
    this.setActiveItem(target.dataset.value)

    dropdownBtnLabel.innerHTML = target.dataset.value
    dropdown.hide()
  }

  setActiveItem(activeCountryValue: string): void {
    const items = $list(DROPDOWN_ITEM_SELECTOR, this)
    items.forEach(item => {
      item.classList.toggle('active', item.dataset.value === activeCountryValue)
    })
  }

  createItems(): void {
    const dropdown: FloatElement = $el(DROPDOWN_SELECTOR, this)
    const options: HTMLOptionElement[] = $list(DROPDOWN_OPTION_SELECTOR, this)
    const fragment = document.createDocumentFragment()

    if (!dropdown) {
      return
    }

    options.forEach(option => {
      const item = document.createElement('div')
      const clonedOption = option.cloneNode(true)

      item.classList.add('dropdown__item')
      item.setAttribute('tabindex', '0')
      item.dataset.value = option.value
      item.dataset.provinces = option.dataset.provinces
      item.replaceChildren(...clonedOption.childNodes)

      fragment.appendChild(item)
    })

    replaceNodeChildren(dropdown.element, fragment)
  }
}
